import { GridItemNormalizer } from '../types';

export default class PlantsHRObjectNormalizer implements GridItemNormalizer {
  support(value: any): boolean {
    return value?.__typename === 'object_PlantsHR';
  }

  normalize(value: any) {
    return value?.name;
  }

  normalizeAsSelectValue(value: any) {
    return this.normalize(value);
  }

  getRequiredFields() {
    return {
      id: '',
      name: '',
      code: '',
    };
  }
}
